import { Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const imgUrl = (p) => (p ? (p.startsWith("http") ? p : `${BACKEND}${p}`) : null);
const maskCss = (url) => ({
  WebkitMaskImage: `url("${url}")`, maskImage: `url("${url}")`,
  WebkitMaskSize: "contain", maskSize: "contain",
  WebkitMaskPosition: "center", maskPosition: "center",
  WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat",
});

// Transient fallback while the server bake warms: marking PNG alpha = shape only (RGB ignored),
// filled ivory and clipped to the horse silhouette (base art alpha). Never stacks raw marking art.
const RenderBadge = ({ compact }) => (
  compact ? (
    <span className="absolute right-0.5 top-0.5 h-2 w-2 animate-pulse rounded-full bg-amber-500 ring-1 ring-white" style={{ zIndex: 5 }} title="Finishing artwork…" data-testid="render-progress-dot" />
  ) : (
    <span className="absolute bottom-1.5 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-black/60 px-2 py-0.5 text-[10px] font-semibold text-white backdrop-blur-sm" style={{ zIndex: 5 }} data-testid="render-progress-badge">
      <Loader2 size={10} className="animate-spin" /> Finishing artwork…
    </span>
  )
);

export const MarkingLayers = ({ base, layers, compact = false }) => {
  const shown = (layers || []).filter((l) => l.asset_id && !l.missing);
  if (!base || !shown.length) return null;
  return (
    <>
    <RenderBadge compact={compact} />
    <div className="pointer-events-none absolute inset-0" style={{ zIndex: 2, ...maskCss(imgUrl(base)) }} data-testid="marking-mask-fallback">
      {shown.map((l, i) => (
        <div key={i} className="absolute inset-0" style={{
          background: "rgb(250, 247, 239)", ...maskCss(imgUrl(l.asset_id)),
          transform: `translate(${l.x || 0}%, ${l.y || 0}%) scale(${(l.scale ?? 100) / 100}) rotate(${l.rot || 0}deg)`, transformOrigin: "center",
        }} />
      ))}
    </div>
    </>
  );
};
